export default __webpack_public_path__ + "static/media/con_MOVG07.dc594668.jpg";